import { FC, ReactNode } from "react";
import TextSubtitle from "apps/website/components/base/Text/TextSubtitle/TextSubtitle";
import {
  TextSubtitleVariantsProps,
} from "apps/website/components/base/Text/TextSubtitle/styles";
import TextBody from "apps/website/components/base/Text/TextBody/TextBody";
import {
  TextBodyVariantsProps,
} from "apps/website/components/base/Text/TextBody/styles";
import Icon from "apps/website/components/base/Icon/Icon";
import {
  boldenBacktickText,
} from "apps/website/utils/website/boldenBacktickText";
import { Align, defaultAlignClassMap } from "apps/website/maps/Flex.map";
import cx from "apps/website/utils/misc/cx";

import { BaseCheckbox, IBaseCheckboxProps } from "../BaseCheckbox/BaseCheckbox";

interface IStyleOptions {
  alignItems?: Align;
  titleTextSize?: TextSubtitleVariantsProps["size"];
  descriptionTextSize?: TextBodyVariantsProps["size"];
};

export interface IDefaultCheckboxProps extends IBaseCheckboxProps {
  title?: string;
  description?: ReactNode;
  styleOptions?: IStyleOptions
}

interface IDescriptionText {
  descriptionTextSize: IStyleOptions["descriptionTextSize"],
  description: ReactNode
  title?: string
}

const DescriptionText = (
  { descriptionTextSize, description, title }: IDescriptionText,
) => {
  return (
    <TextBody
      size={descriptionTextSize ?? ((description && title) ? 3 : 2)}
      className="[&>a]:font-normal"
    >
      { typeof description === "string" ? boldenBacktickText(description) : description }
    </TextBody>
  );
};

const DefaultCheckbox: FC<IDefaultCheckboxProps> = (props) => {
  const { title, description, styleOptions, ...baseProps } = props;

  const defaultAlign = (description && title) ? "start" : "center";

  const computedWrapperClassName = cx(
    "flex",
    baseProps.wrapperClassName,
    defaultAlignClassMap[styleOptions?.alignItems || defaultAlign],
  );

  return (
    <BaseCheckbox {...baseProps} wrapperClassName={computedWrapperClassName}>

      <span className="block rounded border-2 border-black border-solid max-w-6 max-h-6 w-6 h-6 box-border mr-3 text-white [&>*]:hidden
      peer-checked:[&>*]:block peer-checked:bg-black peer-disabled:border-graphite-grey peer-disabled:bg-cool-grey-40 peer-disabled:cursor-not-allowed
      peer-focus-visible:focus-visible">
        <Icon icon="tickShort" color="inherit" size="fit" />
      </span>

      <div className="flex flex-col gap-2 peer-disabled:[&_*]:text-graphite-grey peer-disabled:cursor-not-allowed flex-1">
        { title && (
          <TextSubtitle size={styleOptions?.titleTextSize ?? 3}>
            { title }
          </TextSubtitle>
        ) }
        { description && (
          <DescriptionText
            descriptionTextSize={styleOptions?.descriptionTextSize} description={description} title={title}
          />
        ) }
      </div>

    </BaseCheckbox>
  );
};

export default DefaultCheckbox;
